import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useResetAdminPassword() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { password: string; password_confirmation: string }) => {
      const response = await fetch('/admin/api/iam/reset_password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        throw new Error('Failed to reset password');
      }
      return await response.json();
    },
    onSuccess: () => {
      // IAMデータのキャッシュを無効化して、最新のデータを取得
      queryClient.invalidateQueries({ queryKey: ['admin', 'iam'] });
    },
  });
}
